import React from "react";
import { SwiperSlide } from "swiper/react";
import Column from "apps/website/components/layout/Column/Column";

import Carousel from "../Carousel";

import VetAndExpertsCardItem, {
  VetAndExpertsCardItemProps,
} from "./components/VetAndExpertsCardItem";

export interface VetsAndExpertsCardCarouselProps {
  items: VetAndExpertsCardItemProps[]
}
const VetsAndExpertsCardCarousel: React.FC<VetsAndExpertsCardCarouselProps> = ({ items }) => (
  <Column component="VetsAndExpertsCardCarousel" >
    <Carousel
      spaceBetween="default"
      pagination={false}
      showNavigation={false}
      breakpoints={{ default: 1.2, lg: 4 }}
    >
      { items.map((item, index) => (
        <SwiperSlide key={ index} >
          <VetAndExpertsCardItem { ...item } />
        </SwiperSlide>
      )) }
    </Carousel>
  </Column>
);

export default VetsAndExpertsCardCarousel;
